<div [class.wrap]="component?.wrap">
    <div class="_scroll">
        <div class="b-col-1 b-a _container">
            <table>
                <tbody>
                    @for (row of component?.rows; track $index) {
                    <tr>
                        @for (field of row.fields; track $index) {
                        @if (row.isHeader) {
                        <th class="p-a-2 center"
                            [ngClass]="row.font || 's1'"
                            [attr.colspan]="field.colSpan || 1"
                            [attr.rowspan]="field.rowSpan || 1"
                            [style.--width.%]="100 / (row.fields?.length || 1)"
                            [style.backgroundColor]="row.backgroundColor"
                            [style.color]="row.color || field.color"
                            *iCms="'text' of field; content: 'html'"></th>
                        } @else{
                        <td class="p-a-2 center"
                            [ngClass]="row.font || 'p1'"
                            [attr.colspan]="field.colSpan || 1"
                            [attr.rowspan]="field.rowSpan || 1"
                            [style.--width.%]="100 / (row.fields?.length || 1)"
                            [style.backgroundColor]="row.backgroundColor"
                            [style.color]="row.color || field.color"
                            *iCms="'text' of field; content: 'html'"></td>
                        }
                        }
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>